import { render, staticRenderFns } from "./ContestTab.vue?vue&type=template&id=468e772e&"
import script from "./ContestTab.vue?vue&type=script&lang=ts&"
export * from "./ContestTab.vue?vue&type=script&lang=ts&"
import style0 from "./ContestTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports